import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { AtsGetJobPostingSettingsSmartActionsDocument } from 'generated/resources/graphql'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { PhaseChangedAction } from './PhaseChangedAction'
import { RejectionEmailsAction } from './RejectionEmailsAction'
import { SmartActionsSkeleton } from './SmartActionsSkeleton'

interface Props {
  jobId: number
}

export const SmartActions = ({ jobId }: Props) => {
  const { data, loading } = useQuery(AtsGetJobPostingSettingsSmartActionsDocument, {
    variables: {
      id: jobId,
    },
  })

  useEffect(() => {
    track(trackingEvents.ats.jobSettingsAccessSmartActions)
  }, [])

  const smartActions = data?.ats.candidateEmailActions

  if (loading || !smartActions) {
    return <SmartActionsSkeleton />
  }

  const rejectionEmailsActions = smartActions.filter((action) => action.actionType === 'reject')
  const phaseChangedActions = smartActions.filter((action) => action.actionType === 'phase_changed')

  return (
    <>
      <Box gap="s8">
        <Text size="400" color="grey1000" weight="semibold">
          {i18n.t('ats.job_posting_settings.smart_actions.title')}
        </Text>
        <Text size="300" color="grey800">
          {i18n.t('ats.job_posting_settings.smart_actions.description')}
        </Text>
        <HelpCenterLink name="applicant_tracking_system">
          {i18n.t('common.learn_more')}
        </HelpCenterLink>
      </Box>

      <Box paddingTop="s40" gap="s32">
        <RejectionEmailsAction smartActions={rejectionEmailsActions ?? []} jobId={jobId} />
        <PhaseChangedAction smartActions={phaseChangedActions ?? []} jobId={jobId} />
      </Box>
    </>
  )
}
